import { Injectable } from '@angular/core';
import { ObservCart } from '@brunsker/libs/portal-do-vendedor/ui/observations-text-area';
import { ProductLocalStorage } from '@brunsker/libs/portal-do-vendedor/ui/product-card';
import { CartData } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/services/domain/carrinho/models/cart.models';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  finiteDecimalValue,
  parseDecimalValue,
  sameCartPackaging,
} from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/utils/product-packaging';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  storage: Storage = sessionStorage;
  groupProduct$$ = new Subject<{
    product: ProductLocalStorage;
    group?: boolean;
  }>();
  cartTotalValue$$ = new BehaviorSubject(0);
  cartSubTotalValue$$ = new BehaviorSubject(0);
  private key!: number;

  public get keyCart() {
    return this.key;
  }

  public set keyCart(value: number) {
    this.key = 0;
  }

  addItemInCart(value: ProductLocalStorage) {
    if (!this.getCart()) {
      this.replaceCart([]);

      return {
        product: value,
      };
    }
    const allItems = this.getCart();
    const findItem = allItems.find(
      (item: ProductLocalStorage) => sameCartPackaging(item, value)
    );
    if (findItem) return { product: value, group: true };

    return {
      product: value,
    };
  }

  getCart(): any {
    const CART_KEY = `${this.key}-cart`;
    const cart = JSON.parse(this.storage.getItem(CART_KEY) || '[]');

    if (!Array.isArray(cart)) return [];

    return cart.map((item: ProductLocalStorage) => {
      const preco = finiteDecimalValue(item.preco);
      const qtd = finiteDecimalValue(item.qtd);
      const parsedDiscountPrice = parseDecimalValue(item.precoComDesconto);
      const hasValidDiscountPrice =
        item.precoComDesconto !== null &&
        item.precoComDesconto !== undefined &&
        Number.isFinite(parsedDiscountPrice);
      const precoComDesconto = hasValidDiscountPrice
        ? parsedDiscountPrice
        : preco;
      const desconto = finiteDecimalValue(
        item.desconto,
        finiteDecimalValue(item.percentual),
      );
      const percentual = finiteDecimalValue(item.percentual, desconto);
      const subTotal = Number((precoComDesconto * qtd).toFixed(2));

      return {
        ...item,
        preco,
        qtd,
        desconto,
        percentual,
        precoComDesconto,
        subTotal,
        valorDescontoAntigo: finiteDecimalValue(item.valorDescontoAntigo),
      };
    });
  }

  replaceCart(value: any) {
    const CART_KEY = `${this.key}-cart`;
    this.storage.setItem(CART_KEY, JSON.stringify(value));
  }

  getTotalCart() {
    const CART_KEY = `${this.key}-total-cart`;
    const cart = this.getCart();
    const totalCart = cart.reduce(
      (acc: any, curr: { preco: number; qtd: number }) => {
        return acc + curr.preco * curr.qtd;
      },
      0
    );
    const totalCartWithDescount = cart
      .reduce(
        (acc: any, curr: { preco: number; qtd: number; subTotal: number }) => {
          return acc + curr.subTotal;
        },
        0
      )
      .toFixed(2);

    this.storage.setItem(CART_KEY, JSON.stringify(totalCart));
    this.cartTotalValue$$.next(totalCart);
    this.cartSubTotalValue$$.next(+totalCartWithDescount);
  }

  saveDesconto(cart: CartData, storageIndex: number){
    const cartOld = this.getCart();

    cartOld[storageIndex].desconto = cart.desconto;
    cartOld[storageIndex].precoComDesconto = cart.precoComDesconto
  }

  removeItemInCart(value: any) {
    const CART_KEY = `${this.key}-cart`;
    const allItems = this.getCart();
    const removeItem = allItems.splice(allItems.indexOf(value), 1);
    this.storage.setItem(CART_KEY, JSON.stringify(removeItem));
  }

  resetCart() {
    const CART_KEY = `${this.key}-cart`;
    const TOTAL_CART_KEY = `${this.key}-total-cart`;
    const OBSERV_CART_KEY = 'observCart-cart';
    const cart = this.getCart();

    cart.forEach((item: ProductLocalStorage, index: number) => {
      this.storage.removeItem(`${index}-${item.id}-ca`);
    });

    this.storage.removeItem(CART_KEY);
    this.storage.removeItem(TOTAL_CART_KEY);
    this.storage.removeItem(OBSERV_CART_KEY);
    this.storage.removeItem('cart-rodape');
    this.storage.removeItem('numautorizacao');
    this.storage.removeItem('prefix');
  }

  getObserv(): ObservCart | null {
    const OBSERV_CART_KEY = `observCart-cart`;
    const obserNull = (
      JSON.parse(this.storage.getItem(OBSERV_CART_KEY) ?? 'null')
    ) as ObservCart | null
    return obserNull;
  }

  addObservationCart(value: ObservCart) {
    const OBSERV_CART_KEY = `observCart-cart`;

    this.storage.setItem(OBSERV_CART_KEY, JSON.stringify(value));
  }
}
